export default "__VITE_ASSET__e2e4fb34__"